const commonEn = require('./common');
const componentsEn = require('./components/index');
const pagesEn = require('./pages');

module.exports = {
  common:commonEn,
  components: componentsEn,
  pages:pagesEn,
};
